<mat-form-field>
  <mat-label>{{label}}</mat-label>
  <mat-select multiple (openedChange)="onOpenMultiSelect()" [(ngModel)]="selectedOptions"
    (ngModelChange)="onSelectChange()">
    <div class="select-container">
      <mat-optgroup>
        <mat-form-field>
          <mat-label>Search</mat-label>
          <input matInput #search autocomplete="off" aria-label="Search" [formControl]="searchControl">
          <button [disableRipple]="true" *ngIf="search.value" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearSearch($event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </mat-optgroup>
      <mat-optgroup>
        <div *ngIf="filteredOptions.length === 0">{{'shared.components.multipleSelectFilter.noResult.fullLabel' |
          translate}}</div>
        <mat-option *ngFor="let value of filteredOptions" [value]="value.id">
          {{value.label}}
        </mat-option>
      </mat-optgroup>
    </div>
  </mat-select>
</mat-form-field>